import getQueryParams from '../../../../../utils/getQueryParams'
import { getCurrentDate } from '../../../../../helpers/getCurrentDate'

const getManipulationContext = () => {
  const { preview, favourites: favouritesProducts } = getQueryParams()

  return {
    currentDate: getCurrentDate(),
    isPreview: preview === 'true',
    favouriteProductIds: favouritesProducts ? favouritesProducts.split(',') : [],
  }
}

export default getManipulationContext
